export default "__VITE_ASSET__DocMJaUg__"